const t = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 24A12 12 0 1 0 0 12a12 12 0 0 0 12 12ZM7.5 9A1.5 1.5 0 0 1 9 7.5h6A1.5 1.5 0 0 1 16.5 9v6a1.5 1.5 0 0 1-1.5 1.5H9A1.5 1.5 0 0 1 7.5 15Z" fill="currentColor"></path></svg>';
export {
  t as default
};
